import React, { useContext, useState } from "react";
import {
  Form,
  Input,
  Button,
  Select,
  Radio,
  Space,
  Popover,
  Checkbox,
} from "antd";
import { AppContext } from "../../context";
import { countryList } from "../../constants/countryList";
import { districtList } from "../../constants/districtList";
import { BsLock } from "react-icons/bs";
import { MailOutlined } from "@ant-design/icons";
import { FaInfoCircle } from "react-icons/fa";
import "./UserInfoForm.css";

const tailLayout = {
  wrapperCol: {
    offset: 4,
    span: 16,
  },
};

function NewPasswordForm({
  setIsModalVisible,
  form,
  onFinish,
  showPrivacyAndTerms,
  actionButtonText,
  disableUserCategorySelection = false,
}) {
  const info = useContext(AppContext);
  const [isPortugal, setIsPortugal] = useState(false);
  const [userCategory, setUserCategory] = useState(null);
  const [fields, setFields] = useState({});
  const { Option } = Select;
  return (
    <div style={{ width: "90%", margin: "auto auto" }}>
      <Form
        form={form}
        onFinish={onFinish}
        layout={"vertical"}
        initialValues={{
          language: info.language,
        }}
        size="small"
        onFieldsChange={() => {
          const fields = form.getFieldsValue();
          setFields({ ...fields });
        }}
      >
        <Form.Item
          name="email"
          rules={[
            {
              required: true,
              type: "email",
              message: info.t("insertEmail"),
            },
          ]}
        >
          <Input prefix={<MailOutlined />} placeholder="Email"></Input>
        </Form.Item>
        <Form.Item
          name="password"
          rules={[
            {
              required: true,
              message: "",
            },
            {
              validator: (_, value) =>
                /[*@!#%&()^~{}"$*-.,:;|ªº´`?<>]+/.test(value) &&
                value.length >= 10
                  ? Promise.resolve()
                  : Promise.reject(new Error(info.t("passwordRequirements"))),
            },
          ]}
        >
          <Input.Password prefix={<BsLock />} placeholder="Password" />
        </Form.Item>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
            gap: 10,
          }}
        >
          <Button
            type="primary"
            htmlType="submit"
            style={{
              // width: "100%",
              flexGrow: 1,
              marginLeft: -1,
              marginBottom: 10,
              backgroundColor: "#5382a4",
            }}
          >
            {actionButtonText}
          </Button>
          <Button
            type="default"
            htmlType="button"
            onClick={() => setIsModalVisible(false)}
            style={{ flexGrow: 1 }}
          >
            {info.t("cancel")}
          </Button>
        </div>
      </Form>
    </div>
  );
}

export default NewPasswordForm;
